
import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Pack from "./pack";
import WorkspaceService from "services/workspace-service";
import { usePermissions } from "context"; // [NEW]
import UpgradePopup from "layouts/components/Upgrade"; // [NEW]

function Addons() {
    const [myAddons, setMyAddons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [entitlements, setEntitlements] = useState(null);
    const [openPackStore, setOpenPackStore] = useState(false);
    const [showRBACPopup, setShowRBACPopup] = useState(false); // [NEW]

    const { hasPermission } = usePermissions(); // [NEW]
    const canManageBilling = hasPermission("billing:manage"); // [NEW]

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const [workspaceAddons, workspaceEntitlements] = await Promise.all([
                WorkspaceService.fetchWorkspaceAddons(),
                WorkspaceService.fetchWorkspaceEntitlements()
            ]);

            setMyAddons(workspaceAddons || []);
            setEntitlements(workspaceEntitlements || {});

        } catch (error) {
            console.error("Failed to fetch addons data", error);
        } finally {
            setLoading(false);
        }
    };

    // Group My Addons by Type or just list them textually
    const renderMyAddons = () => {
        if (myAddons.length === 0) {
            return (
                <Alert severity="info" sx={{ mt: 2 }}>
                    You have not purchased any add-ons yet.
                </Alert>
            );
        }

        return (
            <Grid container spacing={2} mt={1}>
                {myAddons.map((ua) => (
                    <Grid item xs={12} md={6} lg={4} key={ua._id}>
                        <Card sx={{ p: 2, border: "1px solid #eee", boxShadow: "none" }}>
                            <MDBox display="flex" justifyContent="space-between" alignItems="start">
                                <MDBox>
                                    <MDTypography variant="subtitle2" fontWeight="bold">
                                        {ua.addon_id?.name || "Unknown Pack"}
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text">
                                        Purchased on {(sessionStorage.getItem('demo_role_cache') === "demo_viewer")
                                            ? new Date().toLocaleDateString()
                                            : new Date(ua.purchase_date).toLocaleDateString()}
                                    </MDTypography>
                                </MDBox>
                                <Chip label="Active" color="success" size="small" variant="outlined" />
                            </MDBox>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        );
    };

    return (
        <MDBox>
            {/* 1. My Purchased Add-ons Section */}
            <Card id="my-addons" sx={{ mb: 3, mt: 7, overflow: "visible" }}>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={2}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <MDTypography variant="h6" color="white">
                        My Add-ons
                    </MDTypography>
                </MDBox>
                <MDBox p={2}>
                    {/* Entitlement Summary */}
                    {entitlements?.boosts && (
                        <Alert severity="success" sx={{ mb: 3 }}>
                            <strong>Current Boosts:</strong> +{entitlements.boosts.profiles} Profiles, +{entitlements.boosts.snapshots} Snapshots
                        </Alert>
                    )}
                    {renderMyAddons()}

                    {/* ACTION BUTTONS */}
                    <MDBox display="flex" justifyContent="flex-end" mt={2} gap={1}>
                        <Button
                            startIcon={<ShoppingCartIcon />}
                            color="primary"
                            onClick={() => {
                                if (!canManageBilling) {
                                    setShowRBACPopup(true);
                                    return;
                                }
                                setOpenPackStore(true);
                            }}
                        >
                            BROWSE STORE
                        </Button>
                    </MDBox>
                </MDBox>
            </Card>

            {/* 2. Available Store Modal (Pack Component) */}
            <Dialog
                open={openPackStore}
                onClose={() => setOpenPackStore(false)}
                maxWidth="xl"
                fullWidth
                scroll="body"
            >
                <Pack onClose={() => setOpenPackStore(false)} entitlements={entitlements} />
            </Dialog>

            {/* [NEW] RBAC Restriction Popup */}
            <UpgradePopup
                type="rbac"
                open={showRBACPopup}
                onClose={() => setShowRBACPopup(false)}
                roleRequired="Owner"
                message="Only Workspace Owners can purchase add-ons and manage billing settings."
            />
        </MDBox>
    );
}

export default Addons;
